<template>
  <div
    class="wrapper"
    :class="{
      'g-sidenav-pinned': $sidebar.pinSidebar,
      'g-sidenav-show': $sidebar.showSidebar && !$sidebar.pinSidebar,
      'g-sidenav-hide': !$sidebar.showSidebar && !$sidebar.pinSidebar
    }"
  >
    <side-bar short-title="DSO" title="DSO Việt Nam">
      <template slot="links">
        <template v-for="(item, index) in menus">
          <sidebar-item
            v-if="item.childs.length == 0"
            :key="index"
            :link="item"
          />
          <sidebar-group-item v-else :key="index" :link="item" />
        </template>
      </template>
    </side-bar>
    <div class="main-content bg-primary">
      <dashboard-navbar ref="dashboard-navbar"></dashboard-navbar>

      <div>
        <slide-y-down-transition :duration="300">
          <router-view></router-view>
        </slide-y-down-transition>
        <content-footer
          ref="content-footer"
          v-if="!$route.meta.hideFooter"
        ></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
//:style="`height: calc(100% - ${screenHeight}px)`"
import SideBarState from "@/components/SidebarPlugin/SideBarState";
import DashboardNavbar from "./components/DashboardNavbar";
import ContentFooter from "./components/ContentFooter.vue";
import { SlideYDownTransition } from "vue2-transitions";
export default {
  enums: {
    SideBarState
  },
  components: {
    DashboardNavbar,
    ContentFooter,
    SlideYDownTransition
  },
  data() {
    return {
      screenHeight: 0,
      allMenus: [
        {
          label: "Bảng điều kiển",
          icon: "ni ni ni-tv-2 text-primary",
          name: "dashboard",
          rule: "dashboard_home",
          childs: []
        },
        {
          label: "Quản lý nhân viên",
          icon: "ni ni-single-02 text-info",
          name: "user-manage",
          rule: "user_list",
          childs: []
        },
        {
          label: "Quản lý khách hàng",
          icon: "ni ni-badge text-primary",
          name: "customer-manage",
          rule: "customer_list",
          childs: []
        },
        {
          label: "Quản lý Sản phẩm",
          icon: "ni ni-shop text-danger",
          name: "product-manage",
          rule: "product_list",
          childs: []
        },
        {
          label: "Lệnh chế tạo",
          icon: "ni ni-building text-info",
          name: "manufacture-manage",
          rule: "manufacture_list",
          childs: []
        },
        {
          label: "Nhập xuất kho",
          icon: "ni ni-money-coins text-primary",
          name: "warehouse-manage",
          rule: "receipt-bill_report",
          childs: []
        },
        {
          label: "Quản lý Báo giá",
          icon: "fa fa-clipboard text-danger",
          name: "quotation-manage",
          rule: "quota_list",
          id: "navbar-quota",
          childs: [
            {
              label: "Báo giá đã tạo",
              icon: "fa fa-clipboard-list text-info",
              name: "quotation-manage",
              rule: "quota_list"
            },
            {
              label: "Tạo mới",
              icon: "fa fa-code-branch text-gray",
              name: "add-quotation",
              rule: "quota_create"
            }
          ]
        },
        {
          label: "Quản lý Đơn hàng",
          icon: "fa fa-chart-line text-primary",
          name: "order-manage",
          id: "navbar-order",
          rule: "order_list",
          childs: [
            {
              label: "Đơn hàng đã tạo",
              icon: "fa fa-clipboard-list text-info",
              name: "order-manage",
              rule: "order_list"
            },
            {
              label: "Tạo mới",
              icon: "fa fa-code-branch text-gray",
              name: "add-order",
              rule: "order_create"
            }
          ]
        },
        {
          label: "Thống kê",
          icon: "ni ni-chart-pie-35 text-info",
          name: "report-manage",
          rule: "receipt-bill_turnover",
          id: "navbar-report",
          childs: [
            {
              label: "Kim ngạch",
              icon: "ni ni-credit-card text-warning",
              name: "turnover-manage",
              rule: "receipt-bill_turnover"
            },
            {
              label: "Kim ngạch Nhân viên",
              icon: "ni ni-paper-diploma text-primary",
              name: "turnover-user-manage",
              rule: "receipt-bill_turnover"
            },
            {
              label: "Công nợ",
              icon: "fa fa-calculator text-danger",
              name: "debt-manage",
              rule: "receipt-bill_debt",
              childs: []
            },
            {
              label: "Lịch sử thanh toán",
              icon: "fa fa-calculator text-info",
              name: "history-payment",
              rule: "receipt-bill_history",
              childs: []
            }
          ]
        },
        {
          label: "Cài đặt",
          icon: "ni ni-settings text-red",
          id: "navbar-role",
          childs: [
            {
              label: "Phân quyền",
              icon: "ni ni-lock-circle-open text-gray",
              name: "role-manage",
              rule: "role_list"
            },
            {
              label: "Cấu hình",
              icon: "ni ni-email-83 text-gray",
              name: "config",
              rule: "config_list"
            },
            {
              label: "Màu sắc",
              icon: "ni ni-palette text-red",
              name: "color",
              rule: "color_list"
            }
          ]
        }
      ],
      menus: []
    };
  },
  mounted() {
    this.validatePermissionMenu();
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.doPinSidebar(!this.$sidebar.pinSidebar);
    },
    validatePermissionMenu() {
      this.allMenus.forEach(menu => {
        if (menu.childs.length > 0) {
          let submenu_exists = false;
          let menuGroup = Object.assign({}, menu);
          menuGroup.childs = [];
          for (let i = 0; i < menu.childs.length; i++) {
            const item = menu.childs[i];
            if (this.$permission(item.rule)) {
              submenu_exists = true;
              menuGroup.childs.push(item);
            }
          }
          if (submenu_exists) {
            this.menus.push(menuGroup);
          }
        } else {
          if (this.$permission(menu.rule)) {
            this.menus.push(menu);
          }
        }
      });
    }
  }
};
</script>
